module.exports = __webpack_public_path__ + "static/media/3.4b6c584e.png";